import { Static } from '@sinclair/typebox';
import { ListResponseSchema } from '../../shared/utils/list-response.schema';
import { EmailSenderSchema } from './sender.schema';

export const GetEmailSendersResponseSchema = ListResponseSchema(EmailSenderSchema);

export type GetEmailSendersResponse = Static<typeof GetEmailSendersResponseSchema>;
